import mitt, { type Emitter } from "mitt";

export enum EventType {
  onLogout = "onLogout",
}

type PayloadType = string | undefined;

const implementation: Emitter<Record<EventType, PayloadType>> = mitt();

export const EventBus = {
  emit: ({ eventType, payload }: { eventType: EventType; payload?: PayloadType }): void => {
    implementation.emit(eventType, payload);
  },
  on: ({ eventType, callback }: { eventType: EventType; callback: (payload: PayloadType) => void }): void => {
    implementation.on(eventType, callback);
  },
};
